<template>
    <v-app>
        <v-main>
            <div class="cplug-logo ma-5">
                <v-img
                    :src="require('@/assets/img/connectplug-logo-branca.png')"
                    max-width="300px"
                ></v-img>
            </div>

            <v-container fluid class="fill-height">
                <router-view></router-view>
                <notification-handler></notification-handler>
            </v-container>
        </v-main>

        <div
            class="full-page-background"
            :style="{
                background:
                    'url(' + require('@/assets/img/background.png') + ')',
            }"
        ></div>
    </v-app>
</template>

<script>
import NotificationHandler from '@/components/notifications/NotificationHandler'

export default {
    components: {
        'notification-handler': NotificationHandler,
    },
}
</script>
